import { action, computed, observable, set } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class AccountsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAsync() {
        const accounts = await this.httpClient.get<Mri.Accounts.Account[]>(`/api/v1/accounts`);

        setMap(this.accounts, accounts, a => a.accountNumber);
    }

    @observable
    public accounts = new Map<string, Mri.Accounts.Account>();

    private readonly httpClient: HttpClient;
}
